import api from "./api";

// Value-Added analysis (FBPM Ch.6) — VA / BVA / NVA per process step.

/** Steps + a VA/BVA/NVA rollup for a process. */
export async function getValueAnalysis(processId) {
  return api.get(`/process/${processId}/value-analysis`);
}

/** Save classifications. `items` = [{ process_task_id, value_classification|null,
 *  value_rationale?, bva_business_goal? }]. */
export async function saveValueClassifications(processId, items) {
  return api.patch(`/process/${processId}/value-analysis`, { items });
}

/** Persist AI-suggested classifications. Populate-if-empty by default (never overwrites a
 *  USER override or an existing value); any task_id in `overwriteTaskIds` is force-updated
 *  even if already classified — the per-step opt-in the reviewer ticks in the Value tab.
 *  `items` = [{ task_id, value_classification, value_rationale?, bva_business_goal? }]. */
export async function applyAiClassifications(processId, items, overwriteTaskIds) {
  const body = { items };
  if (Array.isArray(overwriteTaskIds) && overwriteTaskIds.length) {
    body.overwrite_task_ids = overwriteTaskIds;
  }
  return api.patch(`/process/${processId}/value-analysis/ai-suggest`, body);
}
